import { CommonResponse, ID } from '@xver/@types/api';
import { FirewallRule, RulePosition } from '@xver/@types/firewall-rule';
import { FirewallSecurityGroupRuleResponse } from '@xver/@types/firewall-security-group-rule';
import { Pagination, PaginationQueryParams } from '@xver/@types/pagination';
import httpClient from '@xver/libs/axios';

const ENDPOINTS = {
    LIST: (groupId: string) => `/v1/firewalls/security-groups/${groupId}/rules`,
    CREATE: (groupId: string) => `/v1/firewalls/security-groups/${groupId}/rules`,
    BATCH_DELETE: (groupId: string) =>
        `/v1/firewalls/security-groups/${groupId}/rules/batch-delete`,
    UPDATE: (groupId: string, position: number) =>
        `/v1/firewalls/security-groups/${groupId}/rules/${position}`,
    DELETE: (groupId: string, position: number) =>
        `/v1/firewalls/security-groups/${groupId}/rules/${position}`,
    MOVE: (groupId: string, position: number, target: number) =>
        `/v1/firewalls/security-groups/${groupId}/rules/${position}/move?target=${target}`,
};

export function listRules(
    groupId: string,
    query: PaginationQueryParams
): Promise<Pagination<FirewallSecurityGroupRuleResponse>> {
    return httpClient.get(ENDPOINTS.LIST(groupId), {
        params: {
            page: query.page,
            limit: query.limit,
        },
    });
}

export function createRule(
    groupId: string,
    data: FirewallRule
): Promise<ID & Date & FirewallRule & RulePosition> {
    return httpClient.post(ENDPOINTS.CREATE(groupId), data);
}

export function batchDeleteRules(groupId: string, positions: number[]): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.BATCH_DELETE(groupId), { positions });
}

export function updateRule(
    groupId: string,
    data: FirewallRule & RulePosition
): Promise<CommonResponse> {
    return httpClient.put(ENDPOINTS.UPDATE(groupId, data.position), data);
}

export function deleteRule(groupId: string, position: number): Promise<CommonResponse> {
    return httpClient.delete(ENDPOINTS.DELETE(groupId, position));
}

export function moveRulePosition(
    groupId: string,
    position: number,
    target: number
): Promise<CommonResponse> {
    return httpClient.post(ENDPOINTS.MOVE(groupId, position, target));
}
